import { actions } from '../../utils/constants';

export const filterGlobal = (filter) => ({
    type: actions.ASYNC_FILTER_GLOBAL,
    payload: filter,
});



// WEBPACK FOOTER //
// ./src/components/global/global.actions.js